import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    box-sizing:border-box;
    outline: 0;
  }

  :root {
    --blue: #292987;
    --blue-white:#E5EEFA;
    --orange: #D66135;
    --title: #011F53;
    --paragraph: #011F53;
    --white: #FFFFFF;
    --black: #121212;
  }

  body {
    background: var(--white);
    overflow-x: hidden;

    ::-webkit-scrollbar {
      width: 10px;
    }
    
    ::-webkit-scrollbar-track {
      background: transparent;
    }
    
    ::-webkit-scrollbar-thumb {
      background-color: var(--title);
      border-radius: 3px;
      border: none;
    }
  }

  body, input, button, h3, h4, h5, h6 {
    font-family: 'Inter', sans-serif;
    color: var(--paragraph)
  }
  
  h1, h2 {
    font-family: 'Inter', sans-serif;
    color: var(--title)
  }

  button {
    cursor: pointer;
  }

  a {
    text-decoration: none;
  }
`;

export default GlobalStyle;